import React from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { NummernListe } from './AppAnleitung';
import { SCHLUESSEL_SCHRITTE } from '../../lib/zweiFaktor';

export const Schluessel = ({ schluessel }) => {
  const kopieren = async () => {
    try {
      await navigator.clipboard.writeText(String(schluessel || '').replace(/\s/g, ''));
      toast.success('Schlüssel kopiert');
    } catch {
      toast.error('Kopieren hat nicht geklappt. Bitte tippen Sie den Schlüssel ab.');
    }
  };
  return (
    <div className="space-y-3" data-testid="zwei-faktor-schluessel">
      <div className="flex items-center gap-2 rounded-lg border bg-slate-50 p-2">
        <code className="min-w-0 flex-1 break-all font-mono text-sm text-slate-900" data-testid="zwei-faktor-schluessel-text">{schluessel}</code>
        <Button type="button" variant="outline" size="icon" onClick={kopieren} aria-label="Schlüssel kopieren" data-testid="zwei-faktor-schluessel-kopieren">
          <Copy className="h-4 w-4" />
        </Button>
      </div>
      <NummernListe punkte={SCHLUESSEL_SCHRITTE} testid="zwei-faktor-schluessel-schritte" />
    </div>
  );
};

export default Schluessel;
